import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";

import {
  StyledText,
  DynamicButton,
  MainHolder,
  Children,
  Body,
} from "../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import {
  AlertModal,
  BackButton,
  FullScreenSelect,
  QuantityControl,
} from "../../../components/common";
import useMashupNWinPickup from "../mashupnwin/hooks/useMashupnWinPickup";
import useSpeedShopping from "./hooks/useSpeedShopping";
// import MashupRedemptionStatus from "./components/MashupRedemptionStatus";
// import RewardItemCard from "./components/RewardItemCard";

const SpeedShoppingPickup = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "SpeedShoppingPickup",
        firebase_screen_class: "SpeedShoppingPickup",
      })
    );
  }, []);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const t = JSON.parse(localStorage.getItem("token"));
    setToken(t);
  }, []);

  const [showAlert, setShowAlert] = useState(false);

  const {
    region,
    regionFmt,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
  } = useMashupNWinPickup();

  const {
    background,
    history,
    bannerAd,
    timerFunc,
    cartQuantity,
    shoppingCartSaveStatus,
    processShoppingCart,
  } = useSpeedShopping();

  useEffect(() => {
    if (shoppingCartSaveStatus?.success) {
      setShowAlert(true);
    }
  }, [shoppingCartSaveStatus]);

  return (
    <>
      <MainHolder>
        <BackButton
          onClick={() => {
            history.goBack();
          }}
        />
        <Children>
          <Header>
            <div style={{ textAlign: "center" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium" }}
                margin='0'
              >
                {"Speed Shopping"}
              </StyledText>
            </div>
          </Header>
          <Body>
            {
              // TODO: Update success property
              showAlert && (
                <AlertModal
                  background={background}
                  success={true}
                  onClick={() => {
                    setShowAlert(false);
                  }}
                >
                  <div style={{ maxWidth: "300px", margin: "10px auto" }}>
                    <StyledText size={24}>Speed Shopping Completed!</StyledText>
                    <div
                      style={{
                        width: "70%",
                        minWidth: "300px",
                        margin: "0 auto 30px auto",
                      }}
                    >
                      <StyledText
                        size={14}
                        style={{
                          fontFamily: "MTNRegular",
                        }}
                      >
                        Your shopping has been successfully submitted. We’ll be
                        in touch.
                      </StyledText>
                    </div>
                    <DynamicButton
                      onClick={() => {
                        history.push(`/home?token=${token}`);
                      }}
                      label={"Okay"}
                      disabled={false}
                      color={background}
                      fullWidth
                    />
                  </div>
                </AlertModal>
              )
            }
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <img src={bannerAd} style={{ width: "100%" }} />

              <hr
                style={{
                  margin: "30px 0",
                  borderTop: "none",
                  borderBottom: "1px solid #ddd",
                }}
              />

              <StyledText>Quantity of items - {cartQuantity}</StyledText>

              <div style={{ marginBottom: "150px", marginTop: "50px" }}>
                <StyledText size={18} style={{ fontFamily: "MTNRegular" }}>
                  Pickup from an MTN Office{" "}
                </StyledText>
                <FullScreenSelect
                  placeholder='Region'
                  data={regionFmt}
                  selected={region}
                  setValue={setRegion}
                  activeColor={background}
                />
                <FullScreenSelect
                  placeholder='MTN Office'
                  data={officeLocations}
                  selected={officeLocation}
                  setValue={setOfficeLocation}
                  activeColor={background}
                />
              </div>

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={() => {
                      processShoppingCart({ region, officeLocation });
                    }}
                    label={
                      shoppingCartSaveStatus?.isLoading
                        ? "Processing..."
                        : "Checkout"
                    }
                    disabled={
                      cartQuantity < 1 ||
                      !region ||
                      !officeLocation ||
                      shoppingCartSaveStatus?.isLoading
                    }
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default SpeedShoppingPickup;
